import { useRef, useEffect, useState, useCallback } from 'react';

export type UseScrollNotificationReturn = {
  scrollRef: React.RefObject<HTMLDivElement>;
  isAtBottom: boolean;
};

export function useScrollNotification(
  enabled: boolean,
  loading: boolean,
  hasMore: boolean,
  onLoadMore: () => void
): UseScrollNotificationReturn {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isAtBottom, setIsAtBottom] = useState(false);

  const handleScroll = useCallback(() => {
    const el = scrollRef.current;
    if (!el || !enabled) return;

    const scrollBottom = el.scrollTop + el.clientHeight;
    const scrollHeight = el.scrollHeight;
    const nearBottom = scrollHeight - scrollBottom < 60;

    setIsAtBottom(nearBottom);

    if (nearBottom && !loading && hasMore) {
      onLoadMore();
    }
  }, [enabled, loading, hasMore, onLoadMore]);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return undefined;

    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return { scrollRef, isAtBottom };
}
